import { IconName } from '@billy/design-system'

import { ExternalInvoiceBalanceModifierReference } from '../../../../externalInvoices/routes/InvoiceView/elements/InvoiceViewActions/enums/ExternalInvoiceBalanceModifierReference'
import { InvoiceBalanceModifierReference } from '../enums/InvoiceBalanceModifierReference'

export const invoiceBalanceModifierReferenceToIconName: Record<InvoiceBalanceModifierReference, IconName> = {
  [InvoiceBalanceModifierReference.BankPayment]: 'bank',
  [InvoiceBalanceModifierReference.ContactBalancePayment]: 'creditCard',
  [InvoiceBalanceModifierReference.DaybookTransaction]: 'bank',
  [InvoiceBalanceModifierReference.Invoice]: 'file',
  [InvoiceBalanceModifierReference.ExternalInvoice]: 'file',
  [InvoiceBalanceModifierReference.CreditNote]: 'file',
  [InvoiceBalanceModifierReference.InvoiceLateFee]: 'file',
}

export const externalInvoiceBalanceModifierReferenceToIconName: Record<
  ExternalInvoiceBalanceModifierReference,
  IconName
> = {
  [ExternalInvoiceBalanceModifierReference.BankPayment]: 'bank',
  [ExternalInvoiceBalanceModifierReference.ContactBalancePayment]: 'creditCard',
  [ExternalInvoiceBalanceModifierReference.DaybookTransaction]: 'bank',
  [ExternalInvoiceBalanceModifierReference.Invoice]: 'file',
  [ExternalInvoiceBalanceModifierReference.ExternalInvoice]: 'file',
  [ExternalInvoiceBalanceModifierReference.InvoiceLateFee]: 'file',
  [ExternalInvoiceBalanceModifierReference.CreditNote]: 'file',
}
